import { FallbackError } from "@core/domain/errors/fallback.error";
import { AlertDatasource } from "@station/data/datasources/sensor-alert.datasource";
import type { ConnectionAlertUpdateError } from "@station/domain/errors/alert/connection-alert-update.error";
import type { PredefinedAlertUpdateError } from "@station/domain/errors/alert/predefined-alert-update.error";
import type { SensorAlertUpdateError } from "@station/domain/errors/alert/sensor-alert-update.error";
import type {
    ConnectionAlerts,
    ConnectionAlertUpdate,
} from "@station/domain/models/connection-alert.model";
import type { PredefinedAlerts } from "@station/domain/models/predefined-alert.model";
import type {
    SensorAlerts,
    SensorAlertUpdate,
} from "@station/domain/models/sensor-alert.model";
import type { AlertRepository } from "@station/domain/repositories/alert.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class AlertImplRepository implements AlertRepository {
    constructor(
        @inject(AlertDatasource)
        private readonly alertDatasource: AlertDatasource,
    ) {}

    getAllConnectionAlert(
        stationId: string,
    ): ResultAsync<ConnectionAlerts, FallbackError> {
        return this.alertDatasource.fetchAllConnectionAlerts(stationId);
    }

    getAllSensorAlert(
        stationId: string,
    ): ResultAsync<SensorAlerts, FallbackError> {
        return this.alertDatasource.fetchAllSensorAlert(stationId);
    }

    getAllPredefinedAlert(
        stationId: string,
    ): ResultAsync<PredefinedAlerts, FallbackError> {
        return this.alertDatasource.fetchAllPredefinedAlert(stationId);
    }

    getAllCreatedPredefinedAlert(
        stationId: string,
    ): ResultAsync<PredefinedAlerts, FallbackError> {
        return this.alertDatasource.fetchAllCreatedPredefinedAlert(stationId);
    }

    updateConnectionAlert(
        alertId: string,
        connectionAlert: ConnectionAlertUpdate,
    ): ResultAsync<boolean, ConnectionAlertUpdateError> {
        return this.alertDatasource.updateConnectionAlert(
            alertId,
            connectionAlert,
        );
    }

    updateSensorAlert(
        sensorAlert: SensorAlertUpdate,
    ): ResultAsync<boolean, SensorAlertUpdateError> {
        return this.alertDatasource.updateSensorAlert(sensorAlert);
    }

    updatePredefinedAlert(
        stationId: string,
        predefinedAlert: number[],
    ): ResultAsync<boolean, PredefinedAlertUpdateError> {
        return this.alertDatasource.updatePredefinedAlert(
            stationId,
            predefinedAlert,
        );
    }
}
